"use strict";
// models/globals
Object.defineProperty(exports, "__esModule", { value: true });
exports.isset = exports.lv2 = exports.initTranslation = exports._ = exports.phpPath = void 0;
// export const phpPath = "https://alnitac.com/TST000/php/";
exports.phpPath = "php/";
function initTranslation(v) {
    exports._ = v;
    globalThis._ = v;
}
exports.initTranslation = initTranslation;
exports.lv2 = {
    intervalID: 0,
    droits: "",
    app: {
        // si l'idNature n'est pas pr�cis�, il prend la valeur par d�faut "Prestation" dans les lignes de documents
        idNatureDefaut: 2
    },
    ihm: {
        comptabiliteTenueHorsTaxes: "Oui",
        colonneRemiseLignesDocuments: "Oui",
        autoAdjustRowHeight: "Non",
        documentColumnMinWidth: 100,
    },
    numberFormat: undefined,
    verifTexte: function (saisie) {
        return (saisie.replace(/<|>/g, ""));
    },
    verifMontant: function (saisie) {
        // Traitement de la saisie d'un montant
        // pour les utilisateurs qui tapent une virgule � la place du point
        // ou qui mettent plus de deux d�cimales sur un montant
        // La virgule est accept�e, mais remplac�e par le point
        saisie = parseFloat(saisie.replace(/,/g, "."));
        if (saisie == null || saisie == "" || isNaN(saisie)) {
            return ("");
        }
        else {
            return (saisie.toFixed(webix.i18n.decimalSize));
        }
    },
    verifNombre: function (saisie, decimales) {
        // Traitement de la saisie d'un nombre avec sp�cif des d�cimales
        // La virgule est accept�e, mais remplac�e par le point
        saisie = parseFloat(saisie.replace(/,/g, "."));
        if (saisie == null || saisie == "" || isNaN(saisie)) {
            return ("");
        }
        else {
            return (saisie.toFixed(decimales));
        }
    },
    verifQuantite: function (saisie) {
        // Si le nombre est entier, le formatage est celui d'un entier, sinon on retient 3 d�cimales
        saisie = parseFloat(saisie.replace(/,/g, "."));
        if (saisie == null || saisie == "" || isNaN(saisie)) {
            return ("");
        }
        if (Number.isInteger(saisie)) {
            return (saisie);
        }
        else {
            return (saisie.toFixed(3));
        }
    },
    userPrefs: {
        dirty: true,
        clientformwidth: 905,
        prospectformwidth: 905
    },
    trace: function (vv) {
        // @ts-ignore --> D�fini dans index.html
        if (String(trace) == "Oui") {
            webix.message({
                text: vv,
                type: "debug",
                expire: 10000
            });
        }
    },
    // fonction de nettoyage de la saisie
    // suppression des signes inf�rieur et sup�rieur
    clean: function (newValue, field) {
        if (field.data.disabled)
            return; // sinon plantage sans laisser d'adresse
        if (typeof newValue === 'string' || newValue instanceof String) {
            let nn = newValue.replace(/<|>/g, "");
            if (nn != newValue) {
                exports.lv2.trace(nn);
                field.setValue(nn);
            }
        }
    }
};
function isset(vv) {
    if (typeof (vv) === "undefined")
        return false;
    if (typeof (vv) === "string") {
        return vv.length > 0;
    }
    if (typeof (vv) === "number") {
        return Math.abs(vv) > 0.000001;
    }
    return false;
}
exports.isset = isset;
;
